import * as React from "react"

import SubHeader from "components/Shared/SubHeader"
import PhronesisCalendar from "components/Shared/PhronesisCalendar"
import Selectors from "components/Shared/Filters/modules/Vendor"
import GlobalFilterBenchmark from "../GlobalFilterBenchmark"

import * as paths from "constants/paths"
import { BenchmarkFilters, filtersToShow } from "./BenchmarkFilters"
import { Interval } from "components/Shared/PhronesisCalendar/PhronesisCalendar.domain"
import { Tuple } from "components/Shared/Interfaces"

type SubHeaderBenchmarkProps = {
	onChangeCalendar?: (interval: Interval, period: string) => void
	onChangeSelector?: (
		filterId: string,
		selectedFilters: Array<Tuple>,
		filterLevelSelected: string
	) => void
}

const SubHeaderBenchmark: React.FC<SubHeaderBenchmarkProps> = (props) => {
	const {
		onChangeCalendar = () => undefined,
		onChangeSelector = () => undefined,
	} = props

	return (
		<SubHeader
			parentPath={paths.TRANSACTIONAL}
			title={"phronesis.menu.option.transactional.title"}
			subTitle={"phronesis.transactional.application.benchmark.title"}
			filtersToShow={filtersToShow}
			content={
				<>
					<div className="filters-select-container ">
						<Selectors
							onChange={onChangeSelector}
							selectProps={BenchmarkFilters}
						/>
					</div>
					<GlobalFilterBenchmark />
				</>
			}
			titleContent={
				<div className="phronesis-calendar">
					<PhronesisCalendar setDateInterval={onChangeCalendar} />
				</div>
			}
		/>
	)
}

export default SubHeaderBenchmark
